import { z } from 'zod';

/**
 * Request payload schema for attaching a file to a contract.
 * The `fileId` field is sent as `file_id` by the kyClient's case converter.
 */
export const zodAttachContractAttachmentPayloadSchema = z.object({
  fileId: z.uuid(),
  fileMime: z.string().trim().min(1),
  fileName: z.string().trim().min(1),
});

export const zodAttachContractAttachmentEndpointSchema = z.tuple([
  z.literal('contracts'),
  z.uuid(),
  z.literal('attachments'),
]);
